import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(() => {
    const savedLang = localStorage.getItem('language');
    return savedLang || 'en';
  });

  useEffect(() => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
    document.documentElement.dir = (language === 'ar' || language === 'fa') ? 'rtl' : 'ltr';
  }, [language, i18n]);

  const toggleLanguage = () => {
    setLanguage((prev) => {
      if (prev === 'en') return 'ar';
      if (prev === 'ar') return 'fa';
      return 'en';
    });
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    isRTL: language === 'ar' || language === 'fa',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

